export default __webpack_public_path__ + "4d70b36c16bdddc0e2901ab93441960a.jpg";